import React from "react";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import AddIcon from "@material-ui/icons/Add";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";
import AccessibleIcon from "@material-ui/icons/Accessible";
import BusinessIcon from "@material-ui/icons/Business";
import CloseIcon from "@material-ui/icons/Close";
import CachedIcon from "@material-ui/icons/Cached";
import ClearAllIcon from "@material-ui/icons/ClearAll";
import DescriptionIcon from "@material-ui/icons/Description";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import EmailIcon from "@material-ui/icons/Email";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import FilterListIcon from "@material-ui/icons/FilterList";
import GetAppIcon from "@material-ui/icons/GetApp";
import LanguageIcon from "@material-ui/icons/Language";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import LoopIcon from "@material-ui/icons/Loop";
import HomeIcon from "@material-ui/icons/Home";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import HelpIcon from "@material-ui/icons/Help";
import PhoneIcon from "@material-ui/icons/Phone";
import PersonIcon from "@material-ui/icons/Person";
import PublishIcon from "@material-ui/icons/Publish";
import PrintIcon from "@material-ui/icons/Print";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import RemoveIcon from "@material-ui/icons/Remove";
import RestoreIcon from "@material-ui/icons/Restore";
import SendIcon from "@material-ui/icons/Send";
import SearchIcon from "@material-ui/icons/Search";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import ThumbDownIcon from "@material-ui/icons/ThumbDown";
import UpdateIcon from "@material-ui/icons/Update";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";

const MaterialIcon = {
    AccountBalanceIcon,
    AddIcon,
    AlternateEmailIcon,
    AccessibleIcon,
    BusinessIcon,
    CloseIcon,
    CachedIcon,
    DescriptionIcon,
    DeleteForeverIcon,
    ExitToAppIcon,
    EmailIcon,
    GetAppIcon,
    HighlightOffIcon,
    HelpIcon,
    HomeIcon,
    LanguageIcon,
    LocationOnIcon,
    LockIcon,
    LockOpenIcon,
    PersonAddIcon,
    PhoneIcon,
    PersonIcon,
    PublishIcon,
    RemoveIcon,
    RestoreIcon,
    SendIcon,
    VerifiedUserIcon
};

export const MuiIcons = {
    account_balance: <AccountBalanceIcon />,
    account_wallet: <AccountBalanceWalletIcon />,
    add: <AddIcon />,
    alternate_email: <AlternateEmailIcon />,
    accessible: <AccessibleIcon />,
    business: <BusinessIcon />,
    close: <CloseIcon />,
    cached: <CachedIcon />,
    clear_all: <ClearAllIcon />,
    description: <DescriptionIcon />,
    delete_forever: <DeleteForeverIcon />,
    exit_to_app: <ExitToAppIcon />,
    email: <EmailIcon />,
    filter_list: <FilterListIcon />,
    get_app: <GetAppIcon />,
    highlight_off: <HighlightOffIcon />,
    help: <HelpIcon />,
    home: <HomeIcon />,
    language: <LanguageIcon />,
    location_on: <LocationOnIcon />,
    lock: <LockIcon />,
    lock_open: <LockOpenIcon />,
    loop: <LoopIcon />,
    person_add: <PersonAddIcon />,
    phone: <PhoneIcon />,
    person: <PersonIcon />,
    publish: <PublishIcon />,
    print: <PrintIcon/>,
    remove: <RemoveIcon />,
    restore: <RestoreIcon />,
    send: <SendIcon />,
    search: <SearchIcon />,
    thumb_up: <ThumbUpIcon />,
    thumb_down: <ThumbDownIcon />,
    update: <UpdateIcon />,
    verified_user: <VerifiedUserIcon />
};

export default MaterialIcon;
